import EventTypes from "../../../shared/EventTypes";
import AbstractAction from "../AbstractAction";

export default class UpdateDateAction extends AbstractAction {
    constructor(provider, element, field, value) {
        super(provider);

        this.element = element;
        this.field = field;
        this.oldValue = element[field];
        this.newValue = value || null;
    }

    finish() {
        if (!this.validate()) {
            this.emit(EventTypes.DATE_VALIDATION_ERROR, this.element, this.field);
            super.discard();
            return;
        }
        this.element[this.field] = this.newValue;
        this.emit(EventTypes.UPDATE_ELEMENT_DATE, this.element);
        super.finish();
    }

    validate() {
        let added = this.field === 'addedDate' ? this.newValue : this.element.addedDate;
        let removed = this.field === 'removedDate' ? this.newValue : this.element.removedDate;
        if (!added || !removed) return true;

        // Pad shorter date to match length for comparison
        // "2026" should not conflict with "2026-02" — only reject
        // when the removed date is strictly before the added date
        let a = added.padEnd(10, '-00');
        let r = removed.padEnd(10, '-31');
        return r >= a;
    }

    undo() {
        this.element[this.field] = this.oldValue;
        this.emit(EventTypes.UPDATE_ELEMENT_DATE, this.element);
    }

    redo() {
        this.element[this.field] = this.newValue;
        this.emit(EventTypes.UPDATE_ELEMENT_DATE, this.element);
    }
}
